import { Component, input } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatatableColumn } from '../../types/datatable-column';

@Component({
  selector: 'table-datatable-toggle',
  templateUrl: './datatable-toggle.component.html',
  styleUrls: ['./datatable-toggle.component.scss'],
  imports: [MatTooltipModule, MatSlideToggleModule],
})
export class DatatableToggleComponent<T extends object> {
  toggle = input<DatatableColumn<T>['toggle']>();
  row = input<T>();
  value = input<boolean>();

  preventBubble(event: MouseEvent) {
    event.stopPropagation();
  }
}
